<template>
    <div class="contact-back">
      <div class="m-3 d-flex justify-content-center flex-wrap">
        <form class="shadow-lg p-4 m-4 contact" :class="{ 'contact-gray': loading }" ref="form" @submit.prevent="sendEmail">
          <div v-if="loading" class="spinner-grow spinner-center" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="mb-3">
            <label for="emailControl" class="form-label">Email cím *</label>
            <input required v-model="email" type="email" name="email" class="form-control" :disabled="loading" id="emailControl"
             oninvalid="this.setCustomValidity('Kérem adja meg a következő formátumban: nev@pelda.hu')" onchange="this.setCustomValidity('')" placeholder="nev@pelda.hu">
          </div>
          <div class="mb-3">
            <label for="nameControl" class="form-label">Név *</label>
            <input required v-model="name" type="text" name="name" class="form-control" minlength="4" :disabled="loading" id="nameControl"
             oninvalid="this.setCustomValidity('Kérem adja meg a teljes nevét')" onchange="this.setCustomValidity('')" placeholder="Példa Ákos">
          </div>
          <div class="mb-3">
            <label for="phoneControl" class="form-label">Telefonszám *</label>
            <input required v-model="phone" type="tel" pattern=".[0-9]{10,11}" minlength="11" maxlength="15" name="phone" class="form-control" :disabled="loading" id="phoneControl"
             oninvalid="this.setCustomValidity('Kérem adja meg a számot a következő formátumban: +36301234567')" onchange="this.setCustomValidity('')" placeholder="+36301234567">
          </div>
          <div class="mb-3">
            <label for="cityControl" class="form-label">Település *</label>
            <input required v-model="city" name="city" class="form-control" :disabled="loading" placeholder="Veszprém" id="cityControl" list="cities">
             <datalist id="cities">
              <option v-for="city in cities" :key="city" :value="city">{{ city }}</option>
            </datalist>
          </div>
          <div class="mb-3">
            <label for="streetControl" class="form-label">Cím (opcionális)</label>
            <input v-model="address" type="text" name="name" class="form-control" minlength="4" :disabled="loading" id="streetControl" placeholder="Kossuth út 1.">
          </div>
          <div class="mb-3">
            <label for="messageControl" class="form-label">Ajánlatkérés részletei *</label>
            <textarea required rows="8" v-model="message" class="form-control" name="message" :disabled="loading" id="messageControl"
              :placeholder="messagePlaceholder">
            </textarea>
          </div>
          <div class="mb-3">
            <label for="fileControl" class="form-label">Képek csatolása</label>
            <input type="file" class="form-control" ref="file" id="fileControl" accept="image/*" multiple>
          </div>
          <input class="btn btn-primary mb-2" type="submit" :disabled="loading" value="Email Küldése">
          <ToasterComponent v-if="toasterData.show" :title="toasterData.message" :type="toasterData.type" timeoutMs=5000 />
        </form>
      </div>
    </div>
</template>

<script>
import ToasterComponent from './ToasterComponent.vue';

  import emailjs from '@emailjs/browser';


  export default {
    data: () => {
        return {
            name : '',
            email: '',
            phone: '',
            message: '',
            city: '',
            address: '',
            imageHtmls: '',
            messagePlaceholder: `Árnyékoló típusa, Színe.\nHány darab árnyékolóról van szó?\nÁrnyékoldandó felület (ajtó, ablak, terasz)\nMéretek (magasság, szélesség)`,
            loading: false,
            toasterData: {
              message: '',
              type: 'error',
              show: false,
            },
            files: null,
            cities: [],
        }
    },
    methods: {
        async sendEmail() {
          const serviceId = 'service_t9eajxh';
          const templateId = 'template_j4yp2hf';
          const publicKey = 'KcDyEDyRQf-W7H_-M';
          try {
              const files = this.$refs.file.files;
              this.loading = true;
              if(files.length > 0) {
                var urls = await this.handleFiles(files);
                this.imageHtmls = this.constructImageHtmls(urls);
                if(urls == null){
                  this.loading = false;
                  this.showToaster(1500, "Hiba a küldés közben, kérjük próbálja újra!", 'error');
                  return;
                }
              }

              const msg = {
                  email: this.email,
                  name: this.name,
                  phone: this.phone,
                  message: this.message,
                  address: `${this.city}, ${this.address}`,
                  more: this.imageHtmls,
              }

              await emailjs.send(serviceId, templateId, msg, {
                  publicKey: publicKey,
              });
              this.loading = false;
              this.reset();
              this.showToaster(1500, "Az ajánlatkérés elküldésre került!", 'success');
          } catch (error) {
              this.loading = false;
              this.showToaster(1500, "Hiba a küldés közben, kérjük próbálja újra!", 'error');
          }
       },
       async showToaster(timeoutMs, message, type) {
          this.toasterData.message = message;
          this.toasterData.type = type;
          this.toasterData.show = true;
          await new Promise(resolve => setTimeout(resolve, timeoutMs))
          this.toasterData.show = false;
        },
        reset() {
            this.email = '';
            this.name = '';
            this.phone = '';
            this.message = '';
            this.city = '';
            this.address = '';
        },
        async handleFiles(files){
          const result = new Array();
          const timestamp = Date.now();
          const folder = 'email';
          const upload_preset = 'ml_default';
          const public_id = timestamp.toString();
          const api_secret = '2KfFWpal7cgmjMZhPdu8Lq67sGM';
          const api_key = '817369113555741';
          const URL = 'https://api.cloudinary.com/v1_1/arnyekguru/image/upload';
          const formData = new FormData();

          try {
            

          for(let i = 0;i < files.length;i++) {
            const image_public_id = public_id + i.toString();
            var shaInput = `folder=${folder}&public_id=${image_public_id}&timestamp=${timestamp}&upload_preset=${upload_preset}${api_secret}`;
            var hash = await this.sha1(shaInput);
            formData.append("file", files[i]);
            formData.append("api_key", api_key);
            formData.append("timestamp", timestamp);
            formData.append("public_id", image_public_id);
            formData.append("signature", hash);
            formData.append('upload_preset', upload_preset);
            formData.append('folder', folder);

            const requestOptions = {
              method: 'POST',
              body: formData
            };

            try {
              const response = await fetch(URL, requestOptions);
              console.log(response);
              if(response.status == 200) {
                var data = await response.json();
                result.push(data.secure_url);
              } else {
                return null;
              }
            } catch (error) {
              console.log(error);
              return null;
            }
          }
        } catch (error) {
            console.log(error);
          }

          return result;
        },
        async sha1(str) {
          const enc = new TextEncoder();
          const hash = await crypto.subtle.digest('SHA-1', enc.encode(str));
          return Array.from(new Uint8Array(hash))
            .map(v => v.toString(16).padStart(2, '0'))
            .join('');
        },
        constructImageHtmls(urls) {
          var result = ''
          for (let index = 0; index < urls.length; index++) {
            const url = urls[index];
            result += `\n ${url}`;
          }
          return result;
        },
    },
    components: {
      ToasterComponent
    },
    async mounted() {
      var response = await fetch('./static/cities.csv');
      var text = await response.text();
      var cities = text.split('\r\n');
      this.cities = cities;
    }
  };
</script>

<style lang="scss" scoped>
@use '@/assets/style/variables';

.contact {
  background: variables.$light-color;
  width: 50%;
}

.contact-gray {
  filter: brightness(.5);
}

.spinner-center {
  color: variables.$dark-color;
  position: relative;
  margin: auto;
  top: 45%;
}

.contact-back {
  content: "";
  width: 100%;
  background-image: url(https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/contact-hero-bg);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

@media screen and (max-width: 800px) {
  .contact {
    width: 95%;
  }

  .contact-back {
    background-attachment: scroll;
  }
}

</style>